import supportModule from '../../support.module';
import template from './supportFeedComment.component.html';
import style from './supportFeedComment.component.css';

export default supportModule.component('supportFeedComment', {
    template,
    style,
    bindings: {
        comment: '<'
    },
    controller(stringHelper) {
        var vm = this;

        vm.unescape = () => {
            if (vm.comment && vm.comment.body) {
                return stringHelper.unescape(vm.comment.body);
            }
        };
    }
});



// WEBPACK FOOTER //
// ./modules/support/components/support-feed-comment/supportFeedComment.component.js